export const PAGING_TYPES = {
  none: 'none',
  page: 'page',
  question: 'question',
};

const PAGING_LABELS = {
  [PAGING_TYPES.none]: 'None',
  [PAGING_TYPES.page]: 'By Page',
  [PAGING_TYPES.question]: 'By Question',
};

export const PROGRESS_BAR_TYPES = {
  noProgressBar: 'noProgressBar',
  simple: 'simple',
  bar: 'bar',
  percent: 'percent',
};

const PROGRESS_BAR_LABELS = {
  [PROGRESS_BAR_TYPES.noProgressBar]: 'None',
  [PROGRESS_BAR_TYPES.simple]: 'Simple',
  [PROGRESS_BAR_TYPES.bar]: 'Numeric',
  [PROGRESS_BAR_TYPES.percent]: 'Percentage',
};

const getOption = (key, labels) => {
  return {
    key: key,
    text: labels[key] || '',
    value: key,
  };
};

export const getPagingOptions = () => {
  return Object.keys(PAGING_TYPES).map((key) => getOption(key, PAGING_LABELS));
};

export const getProgressBarOptions = () => {
  return Object.keys(PROGRESS_BAR_TYPES).map((key) => getOption(key, PROGRESS_BAR_LABELS));
};
